import { ADVISORY, O2_LOW, POWER_DEMAND, RESERVE_MAX } from "@spacecrew/shared";
import type { Snap } from "../net/ship.svelte.js";

/** The corporate OS's standing advice: the highest-value available action right now. */
export function advisoryFor(snap: Snap): string {
  if (snap.phase !== "running") return "";
  if (snap.drill === "pending") return ADVISORY.drill;
  if (snap.breakers.status !== "idle") return ADVISORY.breaker;
  if (snap.activeEvent === "coolant") return ADVISORY.coolant;
  if (snap.relay.status === "damaged" || snap.relay.status === "carried") return ADVISORY.relay;
  if (snap.o2 <= O2_LOW || snap.power.life < POWER_DEMAND - 1) return ADVISORY.o2;
  if (snap.surge.status === "ready" && snap.reserve < RESERVE_MAX - 30) return ADVISORY.dumpReady;
  if (snap.power.cooling < POWER_DEMAND - 1) return ADVISORY.cooling;
  return ADVISORY.nominal;
}
